import React from "react";
import AppContext from "../Context/Context";
import axiosAuth from "../Axios/Interceptors";
import { useState, useEffect, useRef } from "react";

import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import DragDrop from "../DragDrop/DragDrop";
import moment from "moment";
import {
  getAccessSettings,
  removeNonNumeric,
  SortTheList,
} from "../Shared/Utility";
import InputMask from "../App/InputMask";
import { useGlobalState } from "../Context/GlobalStateContext";
import InputMaskReadOnly from "../App/InputMaskReadOnly";
import Confirmation from "../App/Confirmation";
import * as XLSX from "xlsx";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
export default function CreditNotesData() {
  const globalState = useGlobalState();

  const [creditNotesGridData, setCreditNotesGridData] = useState([]);

  const [showAnimation, setShowAnimation] = useState(false);
  const [canEdit, setCanEdit] = useState(false);

  const [currentView, setCurrentView] = useState(1);

  const [filterData, setFilterData] = useState({
    ProgramID: globalState.TopFilterData.IBBProgramID,
    QuarterID: globalState.TopFilterData.QuarterID,
    IBBScorecardID: 0,
    PFIDealerID: 0,
    PFIBrandID: 2,
  });

  const [programList, setProgramList] = useState<any>([]);

  const [quarterList, setQuarterList] = useState<any>([]);

  const [brandList, setBrandList] = useState<any>([
    {
      PID: 3,
      Name: "PFI Brand 3",
    },
    {
      PID: 4,
      Name: "PFI Brand 4",
    },
  ]);

  const [importerList, setImporterList] = useState<any>([]);
  const [inputData, setInputData] = useState<any>({
    IBBScorecardCreditNoteID: 0,
    IBBScorecardID: 0,
    IBBScorecardInvoiceID: 0,
    Name: "",
    PFIBrandID: 0,
    GeneratedByID: 0,
    GeneratedTimestamp: new Date(),
    YourReference: "",
    FundedFrom: "",
    FinAllocRef: "",
    AmountInLC: 0,
    AmountInUSD: 0,
    CurrencyID: 0,
    OriginatedByID: 0,
    OriginatedTimestamp: new Date(),
    Explanation: "",
    AdditionalCommentary: "",
    ApprovedVDMRef: "",
    Title: "",
    CostCentre: "",
    AccCode: "",
    Status: 0,
  });

  const [invoicesTotalData, setInvoicesTotalData] = useState<any>({});
  const [invoicesList, setInvoicesList] = useState<any>([]);
  const [modelList, setModelList] = useState<any>([]);

  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);

    let QuarterID = params.get("qid") as any;
    if (QuarterID && QuarterID != "") QuarterID = Number(QuarterID);
    else QuarterID = filterData.QuarterID;

    let IBBScorecardID = params.get("scid") as any;
    if (IBBScorecardID && IBBScorecardID != "")
      IBBScorecardID = Number(IBBScorecardID);
    else IBBScorecardID = filterData.IBBScorecardID;

    let PFIDealerID = params.get("dlid") as any;
    if (PFIDealerID && PFIDealerID != "") PFIDealerID = Number(PFIDealerID);
    else PFIDealerID = filterData.PFIDealerID;

    let IBBProgramID = params.get("pid") as any;
    if (IBBProgramID && IBBProgramID != "") IBBProgramID = Number(IBBProgramID);
    else IBBProgramID = filterData.ProgramID;

    setFilterData((prevState: any) => ({
      ...prevState,
      ProgramID: IBBProgramID,
      PFIDealerID: PFIDealerID,
      IBBScorecardID: IBBScorecardID,
      QuarterID: QuarterID,
    }));

    IBBProgramGetProgramListForScorecard(
      IBBProgramID,
      QuarterID,
      IBBScorecardID,
      PFIDealerID
    );
  }, []);

  useEffect(() => {
    if (filterData.ProgramID > 0) {
      IBBProgramGetScorecardListForScorecard();
      IBBScorecardCreditNoteGetCompleteDataSetForForeignKeysCustom();
    }
  }, [filterData.ProgramID, filterData.QuarterID]);

  useEffect(() => {
    if (filterData.ProgramID > 0 && filterData.QuarterID > 0)
      IBBScorecardCreditNoteGetCompleteGridDataCustom();
  }, [filterData.ProgramID, filterData.QuarterID, filterData.IBBScorecardID]);

  useEffect(() => {
    if (inputData.IBBScorecardID > 0 && inputData.PFIBrandID > 0) {
      IBBScorecardGetModelLevelDataForCreditNote();
      getCurrencyIDByIBBScorecardID();
    }
  }, [inputData.IBBScorecardID, inputData.PFIBrandID]);

  function IBBProgramGetProgramListForScorecard(
    IBBProgramID: number,
    QuarterID: number,
    IBBScorecardID: number,
    PFIDealerID: number
  ) {
    if (IBBProgramID == 0) IBBProgramID = filterData.ProgramID;
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.ibbprogramid = IBBProgramID;
    object.numericquarter = QuarterID;
    object.pfidealerid = PFIDealerID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramGetProgramListForScorecard",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          if (result.length > 1 && result[0].length > 0) {
            setProgramList(result[0]);
            if (IBBProgramID == 0) {
              IBBProgramID = result[0][0].IBBProgramID;
              setFilterData((prevState: any) => ({
                ...prevState,
                ProgramID: IBBProgramID,
              }));
            }

            setImporterList(result[1]);

            setQuarterList(result[2]);
            if (QuarterID == 0) {
              let QuarterID = result[2][0].PID;
              setFilterData((prevState: any) => ({
                ...prevState,
                QuarterID: QuarterID,
              }));
            }
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBProgramGetScorecardListForScorecard() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.ibbprogramid = filterData.ProgramID;
    object.numericquarter = filterData.QuarterID;
    object.pfidealerid = filterData.PFIDealerID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBProgram/IBBProgramGetScorecardListForScorecard",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          if (result.length > 0) {
            setImporterList(result[0]);

            // if (result[0].length > 0) {
            //   let IBBScorecardID = result[0][0].PID;
            //   setfilterData((prevState: any) => ({
            //     ...prevState,
            //     IBBScorecardID: IBBScorecardID,
            //   }));
            // }
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBScorecardCreditNoteGetCompleteDataSetForForeignKeysCustom() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.ibbprogramid = filterData.ProgramID;
    object.quarterid = filterData.QuarterID;
    object.pfidealerid = filterData.PFIDealerID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBScorecardCreditNote/IBBScorecardCreditNoteGetCompleteDataSetForForeignKeysCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          if (result.length > 1) {
            setInvoicesList(result[1]);
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBScorecardCreditNoteGetCompleteGridDataCustom() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbprogramid = filterData.ProgramID;
    object.quarterid = filterData.QuarterID;
    object.ibbscorecardid = filterData.IBBScorecardID;
    object.recordsperpage = 1000;
    object.isdeleted = false;
    setCreditNotesGridData([]);
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBScorecardCreditNote/IBBScorecardCreditNoteGetCompleteGridDataCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          if (result.length > 1) {
            if (result[0].length > 0) setInvoicesTotalData(result[0][0]);
            //setCreditNotesGridData(result[1]);

            const deepCopy1 = JSON.parse(JSON.stringify(result[1]));
            const deepCopy2 = JSON.parse(JSON.stringify(result[1]));
            setThisGridListDataWithoutFilters(deepCopy1);
            setCreditNotesGridData(deepCopy2);
            setThisGridListData(deepCopy2);
            thisGridListDataRef.current = deepCopy2;
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBScorecardGetModelLevelDataForCreditNote() {
    let object = {} as any;
    object.appid = AppContext.App;
    object.isdeleted = false;
    object.ibbprogramid = filterData.ProgramID;
    object.quarterid = filterData.QuarterID;
    object.pfidealerid = filterData.PFIDealerID;
    object.ibbscorecardid = inputData.IBBScorecardID;
    object.pfibrandid = inputData.PFIBrandID;
    object.ibbscorecardcreditnoteid = inputData.IBBScorecardCreditNoteID;
    object.type = 1;
    //object.amount = inputData.AmountInLC;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBScorecardCreditNote/IBBScorecardGetModelLevelDataForCreditNote",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status == 1) {
          let result = response.data.Data;
          if (result.length > 1) {
            setModelList(result[0]);
            if (result[1].length > 0) {
              setInputData((prevState: any) => ({
                ...prevState,
                AmountInLC: result[1][0].AmountInLC,
                AmountInLCBK: result[1][0].AmountInLC,
                AmountInUSD: result[1][0].AmountInUSD,
              }));
            }
          }
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function IBBScorecardCreditNoteSaveCustom() {
    if (
      inputData.YourReference != null &&
      (inputData.YourReference == true ||
        inputData.YourReference.toString().toLowerCase() == "true")
    ) {
      let AmountInUSD = inputData.AmountInUSD;

      if (globalState.AppAccessLevelData.DID == 0) {
        let percentageDiff = AmountInUSD / inputData.AmountInLCBK;
        AmountInUSD = inputData.AmountInLC * percentageDiff;
      }

      let object = {} as any;
      object.appid = AppContext.App;
      object.ibbscorecardcreditnoteid = inputData.IBBScorecardCreditNoteID;
      object.ibbscorecardid = inputData.IBBScorecardID;
      object.ibbscorecardinvoiceid = inputData.IBBScorecardInvoiceID;
      object.pfibrandid = inputData.PFIBrandID;
      object.name = inputData.Name;
      object.generatedbyid = inputData.GeneratedByID;
      object.generatedtimestamp = inputData.GeneratedTimestamp;
      object.yourreference = inputData.YourReference;
      object.fundedfrom = inputData.FundedFrom;
      object.finallocref = inputData.FinAllocRef;
      object.amountinlc = inputData.AmountInLC;
      object.amountinusd = AmountInUSD;
      object.currencyid = inputData.CurrencyID;
      object.originatedbyid = inputData.OriginatedByID;
      object.originatedtimestamp = inputData.OriginatedTimestamp;
      object.explanation = inputData.Explanation;
      object.additionalcommentary = inputData.AdditionalCommentary;
      object.approvedvdmref = inputData.ApprovedVDMRef;
      object.title = inputData.Title;
      object.costcentre = inputData.CostCentre;
      object.acccode = inputData.AccCode;
      object.status = inputData.Status;
      setShowAnimation(true);
      axiosAuth
        .post(
          AppContext.AppBaseURL +
            "api/IBBScorecardCreditNote/IBBScorecardCreditNoteSaveCustom",
          object
        )
        .then((response) => {
          setShowAnimation(false);
          if (response.data.Status == 1) {
            let result = response.data.Data;
            setCurrentView(1);
            IBBScorecardCreditNoteGetCompleteGridDataCustom();
          } else {
            AppContext.ShowNotification("error", response.data.Message);
          }
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    } else
      AppContext.ShowNotification("error", "Please accept the disclaimer.");
  }

  function IBBScorecardCreditNoteDeleteRecordCustom(
    IBBScorecardCreditNoteID: number
  ) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.ibbscorecardcreditnoteid = IBBScorecardCreditNoteID;
    setShowAnimation(true);
    axiosAuth
      .post(
        AppContext.AppBaseURL +
          "api/IBBScorecardCreditNote/IBBScorecardCreditNoteDeleteRecordCustom",
        object
      )
      .then((response) => {
        setShowAnimation(false);
        if (response.data.Status === 1) {
          IBBScorecardCreditNoteGetCompleteGridDataCustom();
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function InputMaskOnChangeHandler(e: any) {
    let Amount = removeNonNumeric(e.Value);
    setInputData((prevState: any) => ({
      ...prevState,
      AmountInLC: Amount,
    }));
  }

  function InputMaskOnBlurHandler(e: any) {}

  function getCurrencyIDByIBBScorecardID() {
    var filtered = importerList.filter(
      (item: any) => item.PID == inputData.IBBScorecardID
    );
    if (filtered.length > 0) {
      setInputData((prevState: any) => ({
        ...prevState,
        CurrencyID: filtered[0].CurrencyID,
      }));
    }
  }

  function ConfirmationCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        IBBScorecardCreditNoteDeleteRecordCustom(obj.SelectedID);
      }
    }
    globalState.setConfirmationObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
    });
  }

  ///--States for columnFilter components---///
  const [clearFilters, setClearFilters] = useState(false);
  const [refreshFilters, setRefreshFilters] = useState(false);
  const [getFilteredLists, setGetFilteredLists] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [thisGridListDataWithoutFilters, setThisGridListDataWithoutFilters] =
    useState<any>([]);
  const [thisGridListData, setThisGridListData] = useState<any>([]);
  const thisGridListDataRef = useRef<any | null>(null);
  thisGridListDataRef.current = thisGridListData;
  const [clickPosition, setClickPosition] = useState<any>({ x: null, y: null });
  function ShowColumnFilterList(event: any, Name: string) {
    if (Name === selectedColumnName) {
      setSelectedColumnName("");
    } else {
      setClickPosition({ x: event.clientX, y: event.clientY });
      setSelectedColumnName(Name);
    }
  }

  function filterCheckboxListCallback(FilterData: any) {
    setSelectedColumnName("");
    let l_data = []; //[...COPAInvoicesGridData] as any;
    l_data = [...FilterData];
    //setCOPAInvoicesGridData([...l_data]);

    setThisGridListData([...FilterData]);
    thisGridListDataRef.current = [...FilterData];
  }

  function ClearAllFilters() {
    const deepCopy = JSON.parse(JSON.stringify(thisGridListDataWithoutFilters));
    setCreditNotesGridData(deepCopy);
    setThisGridListData(deepCopy[0]);
    thisGridListDataRef.current = deepCopy[0];
    setClearFilters(!clearFilters);
  }

  //--States for columnFilter components---///

  ////  Sorting Starts    /////

  const [filters, setFilters] = useState(["", "D"]);

  useEffect(() => {
    SetSortingImage();
  }, [creditNotesGridData, currentView]);

  function SetSortingImage() {
    if (
      creditNotesGridData &&
      creditNotesGridData.length > 0 &&
      document.getElementById("imgSortMarketName")
    ) {
      (
        document.getElementById("imgSortMarketName") as HTMLInputElement
      ).innerHTML =
        '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
      (
        document.getElementById("imgSortIBBScorecardName") as HTMLInputElement
      ).innerHTML =
        '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
      (
        document.getElementById("imgSortPFIBrandName") as HTMLInputElement
      ).innerHTML =
        '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
      (
        document.getElementById("imgSortGeneratedByName") as HTMLInputElement
      ).innerHTML =
        '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
      (
        document.getElementById("imgSortGeneratedTimestamp") as HTMLInputElement
      ).innerHTML =
        '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
      (
        document.getElementById("imgSortAmountInLC") as HTMLInputElement
      ).innerHTML =
        '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
      (
        document.getElementById("imgSortStatusName") as HTMLInputElement
      ).innerHTML =
        '<img src="images/none.svg" width="13px" height="15px" alt="B"/>';
    }
    var l_strClassimgAdd =
      '<img src="images/asc.svg" width="13px" height="15px" alt="B"/>';
    if (filters[1] == "D") {
      l_strClassimgAdd =
        '<img src="images/desc.svg" width="13px" height="15px" alt="B"/>';
    }
    if (filters[0] != "")
      (
        document.getElementById("imgSort" + filters[0]) as HTMLInputElement
      ).innerHTML = l_strClassimgAdd;
  }

  function LoadWithSelectedSort(p_strColumnName: any) {
    var l_strSortExpression = filters[0];
    var l_strSortDirection = filters[1];
    if (l_strSortExpression == p_strColumnName) {
      if (l_strSortDirection == "D") {
        filters[1] = "A";
      } else {
        filters[1] = "D";
      }
    } else {
      filters[1] = "D";
    }
    filters[0] = p_strColumnName;
    HandleSortAndLoadData();

    SetSortingImage();
  }

  function HandleSortAndLoadData() {
    if (filters[0] != "") {
      var SortedGridData = SortTheList(
        thisGridListDataRef.current,
        filters[0],
        filters[1]
      );
      HandleDataLoad(SortedGridData);
    } else {
      HandleDataLoad(thisGridListDataRef.current);
    }
  }

  function HandleDataLoad(GridData: any) {
    let data: any = [...GridData];
    setThisGridListData(data);
    SetSortingImage();
  }

  ////  Sorting Ends    ////

  // Download in Excel function
  function DownloadClientsDataInExcel(id: any, name: any) {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
      document.getElementById(id)
    );
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, name);

    XLSX.writeFile(wb, name + ".xlsx");
  }

  return (
    <>
      {showAnimation && <LoadingAnimation />}
      <Confirmation
        ConfirmationObject={globalState.ConfirmationObject}
        ConfirmationCallBack={ConfirmationCallBack}
      />
      {currentView == 1 && (
        <div className="page--contents">
          <div className="page--breadcrumb">
            <a>Internal Credit Note Request Data</a>
          </div>
          <div className="page--data">
            <div className="flex-container">
              <div style={{ width: "33.33%" }}>
                <select
                  className="select-md"
                  value={filterData.ProgramID}
                  onChange={(e) => {
                    setFilterData((prevState: any) => ({
                      ...prevState,
                      ProgramID: Number(e.target.value),
                      QuarterID: 0,
                      IBBScorecardID: 0,
                    }));
                    globalState.setTopFilterData((prevState: any) => ({
                      ...prevState,
                      IBBProgramID: Number(e.target.value),
                      QuarterID: 0,
                    }));
                    IBBProgramGetProgramListForScorecard(
                      Number(e.target.value),
                      0,
                      0,
                      0
                    );
                  }}
                >
                  {programList &&
                    programList.map((Item: any, index: any) => (
                      <option value={Item.PID} key={"programtop" + Item.PID}>
                        {Item.Name}
                      </option>
                    ))}
                </select>

                <select
                  style={{ marginLeft: 5 }}
                  className="select-md"
                  value={filterData.QuarterID}
                  onChange={(e) => {
                    setFilterData((prevState: any) => ({
                      ...prevState,
                      QuarterID: Number(e.target.value),
                      IBBScorecardID: 0,
                    }));
                    globalState.setTopFilterData((prevState: any) => ({
                      ...prevState,
                      QuarterID: Number(e.target.value),
                    }));
                  }}
                >
                  {quarterList &&
                    quarterList.map((Item: any, index: any) => (
                      <option value={Item.PID} key={"quartertop" + Item.PID}>
                        {Item.Name}
                      </option>
                    ))}
                </select>
              </div>
              <div>
                <select
                  className="select-lg"
                  value={filterData.IBBScorecardID}
                  onChange={(e) =>
                    setFilterData((prevState: any) => ({
                      ...prevState,
                      IBBScorecardID: Number(e.target.value),
                    }))
                  }
                >
                  <option value={0} key={"importertop" + 0}>
                    All
                  </option>
                  {importerList &&
                    importerList.map((Item: any, index: any) => (
                      <option value={Item.PID} key={"importertop" + Item.PID}>
                        {Item.Name}
                      </option>
                    ))}
                </select>
              </div>
              <span style={{ width: "33.33%" }}></span>

              <span></span>

              <div className="flex-items">
                {getAccessSettings(2, 12) > 1 && (
                  <a
                    className="btn-link"
                    onClick={() => {
                      setInputData({
                        IBBScorecardCreditNoteID: 0,
                        IBBScorecardID: 0,
                        IBBScorecardInvoiceID: 0,
                        Name: "",
                        PFIBrandID: 0,
                        GeneratedByID: 0,
                        GeneratedTimestamp: new Date(),
                        YourReference: "",
                        FundedFrom: "",
                        FinAllocRef: "",
                        AmountInLC: 0,
                        AmountInUSD: 0,
                        CurrencyID: 0,
                        OriginatedByID: 0,
                        OriginatedTimestamp: new Date(),
                        Explanation: "",
                        AdditionalCommentary: "",
                        ApprovedVDMRef: "",
                        Title: "",
                        CostCentre: "",
                        AccCode: "",
                        Status: 0,
                      });
                      setModelList([]);
                      setCurrentView(2);
                      setCanEdit(true);
                    }}
                  >
                    Add Internal Credit Note Request
                  </a>
                )}

                <a
                  className="btn-primary"
                  title="Export"
                  onClick={() =>
                    DownloadClientsDataInExcel(
                      "tblCreditNotesData",
                      "CreditNotesData"
                    )
                  }
                >
                  <img src="images/export.svg" width="18" height="18" />
                </a>
              </div>
            </div>
            <div className="flex-container">
              <div className="flex-items sm-re-earn">
                <div className="re-earn">
                  <span className="re-val1">
                    <span>Invoiced Amount:</span>
                  </span>
                  <span className="re-val2">
                    $
                    {invoicesTotalData.InvoicedAmount?.toLocaleString(
                      undefined,
                      {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      }
                    )}
                  </span>
                </div>
                <div className="re-earn">
                  <span className="re-val1">
                    <span>Internal Credit Note Requests Issued:</span>
                  </span>
                  <span className="re-val2">
                    $
                    {invoicesTotalData.CreditNotesIssued?.toLocaleString(
                      undefined,
                      {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      }
                    )}
                  </span>
                </div>
                <div className="re-earn">
                  <span className="re-val1">
                    <span>Internal Credit Note Requests Pending:</span>
                  </span>
                  <span className="re-val2">
                    $
                    {invoicesTotalData.CreditNotesPending?.toLocaleString(
                      undefined,
                      {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      }
                    )}
                  </span>
                </div>
                <div className="re-earn">
                  <span className="re-val1">
                    <span>Paid:</span>
                  </span>
                  <span className="re-val2">
                    $
                    {invoicesTotalData.Paid?.toLocaleString(undefined, {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    })}
                  </span>
                </div>
                <span></span>
              </div>
            </div>
            <div className="section-table remove-scroll">
              {creditNotesGridData && creditNotesGridData.length > 0 && (
                <ColumnFilterCheckboxList
                  DataType={1}
                  RefreshFilters={refreshFilters}
                  ClearFilters={clearFilters}
                  GridData={creditNotesGridData}
                  ColumnName={selectedColumnName}
                  ColumnFilterCheckboxListCallback={filterCheckboxListCallback}
                  GetFilteredLists={getFilteredLists}
                  ReturnAllFilterdLists={{}}
                  ClickPosition={clickPosition}
                  Orientation={"Center"}
                  ColumnOrientation={[
                    { Name: "MarketName", Orientation: "Right" },
                  ]}
                />
              )}

              <table
                className="part-head trend-table fixed-table copa-in-d-table"
                id="tblCreditNotesData"
              >
                <thead>
                  <tr>
                    <th>
                      <span
                        className="c-pointer"
                        onClick={(e) => ShowColumnFilterList(e, "MarketName")}
                        data-function="ShowColumnFilterList"
                      >
                        Market
                      </span>

                      <a
                        onClick={() => LoadWithSelectedSort("MarketName")}
                        title="Sort By Market"
                      >
                        <span id="imgSortMarketName"></span>
                      </a>
                    </th>
                    <th>
                      <span
                        className="c-pointer"
                        onClick={(e) =>
                          ShowColumnFilterList(e, "IBBScorecardName")
                        }
                        data-function="ShowColumnFilterList"
                      >
                        Importer
                      </span>

                      <a
                        onClick={() => LoadWithSelectedSort("IBBScorecardName")}
                        title="Sort By Importer"
                      >
                        <span id="imgSortIBBScorecardName"></span>
                      </a>
                    </th>
                    <th>
                      <span
                        className="c-pointer"
                        onClick={(e) => ShowColumnFilterList(e, "PFIBrandName")}
                        data-function="ShowColumnFilterList"
                      >
                        Brand
                      </span>

                      <a
                        onClick={() => LoadWithSelectedSort("PFIBrandName")}
                        title="Sort By Brand"
                      >
                        <span id="imgSortPFIBrandName"></span>
                      </a>
                    </th>
                    <th>
                      <span
                        className="c-pointer"
                        onClick={(e) =>
                          ShowColumnFilterList(e, "GeneratedByName")
                        }
                        data-function="ShowColumnFilterList"
                      >
                        Generated By
                      </span>

                      <a
                        onClick={() => LoadWithSelectedSort("GeneratedByName")}
                        title="Sort By Generated BY"
                      >
                        <span id="imgSortGeneratedByName"></span>
                      </a>
                    </th>
                    <th>
                      Generated On
                      <a
                        onClick={() =>
                          LoadWithSelectedSort("GeneratedTimestamp")
                        }
                        title="Sort By Generated On"
                      >
                        <span id="imgSortGeneratedTimestamp"></span>
                      </a>
                    </th>
                    <th>
                      Amount
                      <a
                        onClick={() => LoadWithSelectedSort("AmountInLC")}
                        title="Sort By AmountInLC"
                      >
                        <span id="imgSortAmountInLC"></span>
                      </a>
                    </th>
                    <th>
                      Status
                      <a
                        onClick={() => LoadWithSelectedSort("StatusName")}
                        title="Sort By Status Name"
                      >
                        <span id="imgSortStatusName"></span>
                      </a>
                    </th>
                    <th className="sm-col"></th>
                  </tr>
                </thead>
                <tbody>
                  {thisGridListData &&
                    thisGridListData.map((item: any, index: any) => (
                      <React.Fragment key={"creditnotelist" + index}>
                        {!item.IsExcluded && (
                          <tr>
                            <td>{item.MarketName}</td>
                            <td>{item.IBBScorecardName}</td>
                            <td>{item.PFIBrandName}</td>
                            <td>{item.GeneratedByName}</td>
                            <td>
                              {item.GeneratedTimestamp != undefined &&
                                item.GeneratedTimestamp != "" && (
                                  <>
                                    {moment(item.GeneratedTimestamp).format(
                                      "DD/MM/YYYY hh:mm:ss a"
                                    )}
                                  </>
                                )}
                            </td>
                            <td className="text-right">
                              {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                item.CurrencyID
                              )}
                              {item.AmountInLC?.toLocaleString(undefined, {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                              })}
                            </td>
                            <td
                              className={`
                               ${item.Status == 1 ? "sig-green" : ""}
                               ${item.Status == 2 ? "sig-red" : ""}
                          `}
                            >
                              {item.StatusName}
                            </td>
                            <td className="sm-col">
                              <div
                                className="width-100 text-center btn-sm-grid"
                                style={{ justifyContent: "flex-start" }}
                              >
                                {getAccessSettings(2, 12) > 1 && (
                                  <a
                                    className="btn-primary btn-grid"
                                    onClick={() => {
                                      setModelList([]);
                                      setCurrentView(3);
                                      item.AmountInLCBK = item.AmountInLC;
                                      setInputData(item);
                                    }}
                                    title={
                                      item.Status == 0
                                        ? "Edit "
                                        : "View Details"
                                    }
                                  >
                                    <img
                                      src="images/edit.svg"
                                      width={15}
                                      height={15}
                                    />
                                  </a>
                                )}
                                {item.Status == 0 &&
                                  getAccessSettings(2, 12) > 1 && (
                                    <>
                                      <a
                                        className="btn-primary btn-grid"
                                        // onClick={() => {
                                        //   IBBScorecardCreditNoteDeleteRecordCustom(
                                        //     item.IBBScorecardCreditNoteID
                                        //   );
                                        // }}
                                        onClick={() => {
                                          globalState.setConfirmationObject({
                                            ShowPopup: true,
                                            Heading: "Confirmation ",
                                            Message:
                                              "Are you sure you want to delete this record?",
                                            ID: 1,
                                            SelectedID:
                                              item.IBBScorecardCreditNoteID,
                                          });
                                        }}
                                        title="Delete"
                                      >
                                        <img
                                          src="images/delete.svg"
                                          width={15}
                                          height={15}
                                        />
                                      </a>
                                    </>
                                  )}
                              </div>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {currentView > 1 && (
        <div className="page--contents">
          <div className="page--breadcrumb">
            {currentView == 2 && canEdit && <a>Add Credit Note Data</a>}
            {currentView == 3 && canEdit && <a>Edit Credit Note Data</a>}
            {!canEdit && <a>Credit Note Details</a>}
          </div>
          <div className="page--data">
            <div className="flex-container">
              <div className="flex-items">
                <b>
                  {programList &&
                    programList.map((item: any, index: any) => (
                      <>
                        {item.PID == filterData.ProgramID && (
                          <span> {item.Name}</span>
                        )}
                      </>
                    ))}

                  {quarterList &&
                    quarterList.map((item: any, index: any) => (
                      <>
                        {item.PID == filterData.QuarterID && (
                          <span> - {item.Name}</span>
                        )}
                      </>
                    ))}
                </b>
              </div>
            </div>

            <div className="type-form">
              <div className="flex-type">
                <span>Importer:</span>
                <select
                  disabled={
                    inputData.IBBScorecardCreditNoteID > 0 ? true : false
                  }
                  className="select-sm"
                  value={inputData.IBBScorecardID}
                  onChange={(e) =>
                    setInputData((prevState: any) => ({
                      ...prevState,
                      IBBScorecardID: Number(e.target.value),
                    }))
                  }
                >
                  <option value={0} key={"importer" + 0}>
                    Please Select
                  </option>
                  {importerList &&
                    importerList.map((Item: any, index: any) => (
                      <option value={Item.PID} key={"importer" + Item.PID}>
                        {Item.Name}
                      </option>
                    ))}
                </select>
              </div>

              <div className="flex-type">
                <span>Brand:</span>
                <select
                  disabled={
                    inputData.IBBScorecardCreditNoteID > 0 ? true : false
                  }
                  style={{ marginLeft: 5 }}
                  className="select-sm"
                  value={inputData.PFIBrandID}
                  onChange={(e) =>
                    setInputData((prevState: any) => ({
                      ...prevState,
                      PFIBrandID: Number(e.target.value),
                    }))
                  }
                >
                  <option value="0">Please Select</option>
                  {brandList &&
                    brandList.map((Item: any, index: any) => (
                      <option value={Item.PID} key={"brand" + Item.PID}>
                        {Item.Name}
                      </option>
                    ))}
                </select>
              </div>

              <div className="flex-type">
                <span>Invoice:</span>
                <select
                  className="select-sm"
                  value={inputData.IBBScorecardInvoiceID}
                  onChange={(e) => {
                    setInputData((prevState: any) => ({
                      ...prevState,
                      IBBScorecardInvoiceID: Number(e.target.value),
                    }));
                  }}
                >
                  <option value={0} key={"Invoice" + 0}>
                    Please Select
                  </option>
                  {invoicesList &&
                    invoicesList.map((item: any, index: any) => (
                      <>
                        {(item.IBBScorecardID == inputData.IBBScorecardID ||
                          inputData.IBBScorecardID == 0) &&
                          (item.PFIBrandID == inputData.PFIBrandID ||
                            item.PFIBrandID <= 2 ||
                            inputData.PFIBrandID <= 2) && (
                            <option value={item.PID} key={"Invoice" + item.PID}>
                              {item.Name}
                            </option>
                          )}
                      </>
                    ))}
                </select>
              </div>

              <div className="flex-type">
                <span>Date:</span>
                <span className="d-input-tp">
                  {moment(inputData.GeneratedTimestamp).format("DD/MM/YYYY")}
                </span>
              </div>
              {/* 
              <div className="flex-type">
                <span>Your Reference:</span>
                <input
                  value={inputData.YourReference}
                  onChange={(e) =>
                    setInputData((prevState: any) => ({
                      ...prevState,
                      YourReference: e.target.value,
                    }))
                  }
                  type="text"
                />
              </div>

              <div className="flex-type">
                <span>Funded From:</span>
                <input
                  value={inputData.FundedFrom}
                  onChange={(e) =>
                    setInputData((prevState: any) => ({
                      ...prevState,
                      FundedFrom: e.target.value,
                    }))
                  }
                  type="text"
                />
              </div>

              <div className="flex-type">
                <span className="c-red">Finance Allocated Reference:</span>
                <input
                  value={inputData.FinAllocRef}
                  onChange={(e) =>
                    setInputData((prevState: any) => ({
                      ...prevState,
                      FinAllocRef: e.target.value,
                    }))
                  }
                  type="text"
                />
              </div> */}
            </div>
            <div className="section-table">
              <span className="span-flex c-red war-flex">
                COMPLETE FOR VRM / EXT WARRANTY ONLY
              </span>
              <span className="span-flex c-red">
                Note: One Brand Per Submission
              </span>
              {modelList.length > 0 && (
                <table
                  className="part-head trend-table fixed-table"
                  id="tblData"
                >
                  <thead>
                    <tr>
                      <th>Model</th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {modelList &&
                      modelList.map((item: any, index: any) => (
                        <React.Fragment key={"sectioncalcdata" + index}>
                          <tr>
                            <td>{item.ModelName}</td>
                            <td className="text-right">
                              {AppContext.GetCurrencyIconBasedOnCurrencyID(
                                inputData.CurrencyID
                              )}
                              {item.ModelValueBasedOnPercentage?.toLocaleString(
                                undefined,
                                {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                }
                              )}
                            </td>
                          </tr>
                        </React.Fragment>
                      ))}
                  </tbody>
                </table>
              )}
              <div className="flex-type crd-note">
                <span>Total CREDIT Note Request:</span>
                <InputMask
                  Disabled={false}
                  Prefix={AppContext.GetCurrencyIconBasedOnCurrencyID(
                    inputData.CurrencyID
                  )}
                  Suffix={""}
                  ToFixed={0}
                  ClassName=""
                  ColumnName="1"
                  Value={Number(inputData.AmountInLC)}
                  PID={1}
                  onChangeHandler={InputMaskOnChangeHandler}
                  onBlurHandler={InputMaskOnBlurHandler}
                />

                {/* <select
                  className="input-field select-field"
                  value={inputData.CurrencyID}
                  onChange={(e) =>
                    setInputData((prevState: any) => ({
                      ...prevState,
                      CurrencyID: e.target.value,
                    }))
                  }
                >
                  <option value="">Please Select</option>
                  <option value="1">Dollar ($)</option>
                  <option value="2">Euro (€)</option>
                  <option value="3">Pound (£)</option>
                </select> */}
              </div>
            </div>
            {/* <div className="section-table">
              <div className="cd-exp">
                <span className="text-ul">Explanation of Credit/Debit:</span>
                <input
                  value={inputData.Explanation}
                  onChange={(e) =>
                    setInputData((prevState: any) => ({
                      ...prevState,
                      Explanation: e.target.value,
                    }))
                  }
                  type="text"
                />
              </div>
              <div className="cd-exp">
                <span className="text-ul">
                  Additional Commentary - Note: This will not appear anywhere on
                  the Importer Document
                </span>
                <input
                  value={inputData.AdditionalCommentary}
                  onChange={(e) =>
                    setInputData((prevState: any) => ({
                      ...prevState,
                      AdditionalCommentary: e.target.value,
                    }))
                  }
                  type="text"
                />
              </div>
              <div className="flex-type">
                <span className="text-ul">
                  <b>Approved Variable Dealer Margin Ref:</b>
                </span>
                <input
                  value={inputData.ApprovedVDMRef}
                  onChange={(e) =>
                    setInputData((prevState: any) => ({
                      ...prevState,
                      ApprovedVDMRef: e.target.value,
                    }))
                  }
                  type="text"
                />
                <span className="c-red">
                  <b>Note: Approved Ref must be entered</b>
                </span>
              </div>
              <div className="flex-type">
                <span className="text-ul">
                  <b>Title:</b>
                </span>
                <input
                  value={inputData.Title}
                  onChange={(e) =>
                    setInputData((prevState: any) => ({
                      ...prevState,
                      Title: e.target.value,
                    }))
                  }
                  type="text"
                />
              </div>
            </div> */}
            <div className="section-table">
              <span className="org-disclaimer">
                <input
                  type="checkbox"
                  className="input-check"
                  checked={inputData.YourReference}
                  onChange={(e) =>
                    setInputData((prevState: any) => ({
                      ...prevState,
                      YourReference: !inputData.YourReference,
                    }))
                  }
                />
                DISCLAIMER - As the originator of this internal Credit/Debit
                Note request - I confirm that the terms of the programme have
                been met and that this claim is consistent with the approved
                programme and is contained within the approved value.
              </span>
              <div className="org-dt">
                <div className="org-main">
                  {(inputData.IBBScorecardCreditNoteID == null ||
                    inputData.IBBScorecardCreditNoteID == 0) && (
                    <span className="org-til">{globalState.LogInUserName}</span>
                  )}
                  {inputData.IBBScorecardCreditNoteID != null &&
                    inputData.IBBScorecardCreditNoteID > 0 && (
                      <span className="org-til">
                        {inputData.GeneratedByName}
                      </span>
                    )}
                  <span>Originator:</span>
                </div>
                <div className="org-main">
                  <span className="org-til">
                    {moment(inputData.OriginatedTimestamp).format("DD/MM/YYYY")}
                  </span>
                  <span>Date:</span>
                </div>
              </div>
            </div>

            {/* <div className="section-table">
              <span className="org-disclaimer">Finance Use Only</span>
              <div className="org-dt">
                <div className="org-main">
                  <span>Cost Centre:</span>
                  <span className="org-til">
                    <input
                      value={inputData.CostCentre}
                      onChange={(e) =>
                        setInputData((prevState: any) => ({
                          ...prevState,
                          CostCentre: e.target.value,
                        }))
                      }
                      type="text"
                    />
                  </span>
                </div>
                <div className="org-main">
                  <span>Acc Code:</span>
                  <span className="org-til">
                    <input
                      value={inputData.AccCode}
                      onChange={(e) =>
                        setInputData((prevState: any) => ({
                          ...prevState,
                          AccCode: e.target.value,
                        }))
                      }
                      type="text"
                    />
                  </span>
                </div>
              </div>
            </div> */}

            <div className="form-btns">
              {inputData.Status == 0 && (
                <a
                  className="btn-primary btn-grid btn-secs"
                  onClick={() => IBBScorecardCreditNoteSaveCustom()}
                >
                  Save
                </a>
              )}
              <a
                className="btn-primary btn-grid btn-secs"
                onClick={() => {
                  setCurrentView(1);
                }}
              >
                Back to List View
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
